import { Box } from '@mui/material';
import { ChangeEvent, useContext } from 'react';
import { TextField, Button } from '@qrios/frontend-library';
import { FormikErrors, FormikTouched } from 'formik';

import Divider from '../../divider/divider';

import { LocalesContext } from '../localesContext';

interface Props<T> {
  handleChange: (field: string, value: unknown) => void;
  handleBlur: (e: ChangeEvent<{ name: string; value: string }>) => void;
  handleOpenNextPage: () => void;
  values: T & { name: string };
  errors: FormikErrors<T & { name: string }>;
  touched: FormikTouched<T & { name: string }>;
}

const NameForm = ({ handleChange, handleBlur, handleOpenNextPage, values, errors, touched }: Props<unknown>) => {
  const locales = useContext(LocalesContext);
  return (
    <form>
      <Box display="flex" flexDirection="column">
        <Box display="flex" alignItems="flex-end" data-testid="name-form-content">
          <Box flex={5} mr={2}>
            <TextField
              data-testid="input-report-name"
              handleChange={e => {
                handleChange(e.target.name, e.target.value);
              }}
              handleBlur={handleBlur}
              name="name"
              label={locales.reportName.label}
              value={values.name}
              placeholder={locales.reportName.placeholder}
              error={errors.name}
              touched={touched.name}
            />
          </Box>
          <Box flex={2} mb={errors.name && touched.name ? 5 : 2}>
            <Button
              size="large"
              type="submit"
              fullWidth={true}
              text="Next"
              data-testid="button-next"
              onClick={e => {
                e.preventDefault();
                handleOpenNextPage();
              }}
            />
          </Box>
        </Box>
        <Divider />
        <Box>
          <p>Important information about report generation: </p>
          Here you can generate a report in CSV format. The generation time depends on the amount of data, so we will
          inform you when the report is ready. Each report can be download an unlimited number of times, but only by 30
          days from it creation. After this time it will by marked as expired.
        </Box>
      </Box>
    </form>
  );
};

export default NameForm;
